/* eslint-disable react/prop-types */
import "./ShowTimelineDetail.css";
import React, { useEffect, useState, useCallback, useMemo, useContext, useRef } from "react";
import { Store } from "../Store/store";
import { API_URL, custom_axios } from "../Common/Common";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import styled from "@emotion/styled";
import { CircularProgress, Box, Divider, IconButton, Tooltip } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Star";
import FavoriteBorderIcon from "@mui/icons-material/StarBorder";
import CommentIcon from "@mui/icons-material/Comment";
import Chip from "@mui/material/Chip";
import Iframe from "react-iframe";
import Linkify from "react-linkify";
import ShowTimelineRead from "../Common/ShowTimelineRead";
import ShowTimelineComment from "./ShowTimelineComment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;

const StyledButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.contrastText};
`;

const ContentContainer = styled(Box)`
  margin: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const StyledMessage = styled("div")`
  max-width: 800px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledFooter = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
  background-color: #f0f0f0;
  margin-top: auto;
`;

const StyledFileList = styled("div")`
  padding: 5px;
  border: 3px solid #ccc;
  background-color: #f9f9f9;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const StyledFileListItem = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 4px;
  width: auto;
`;

const StyledFileLink = styled("a")`
  text-decoration: none;
  color: black;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  color: #1a0dab;
`;

const CommentCount = styled("div")`
  width: 45px;
`;

function ShowTimelineDetail({ open, timelineData, handleClose, nowfavo }) {
  const { state, hubConnection, dispatch } = useContext(Store);
  const [loading, setLoading] = useState(true);
  const [article, setArticle] = useState(null); //timeline情報

  const [openRead, setOpenRead] = useState({ open: false, kbn: "timeline" }); //既読ページ
  const [commentSidebarOpen, setCommentSidebarOpen] = useState(false); //コメントサイドバー
  const [showUserInfoOpen, setShowUserInfoOpen] = useState(false); //ユーザー詳細のオープン情報 ※これがないとサイドバーで綺麗に閉じれない
  const [showuser, setShowUser] = useState({ open: false, honbuid: "" }); //ユーザー詳細ページ

  const [showDeleteOpen, setShowDeleteOpen] = useState(false); //削除確認ダイアログオープン情報 ※これがないとサイドバーで綺麗に閉じれない
  const [showdeleteidex, setDeleteIndex] = useState({ open: false, index: "" }); //削除確認ダイアログ

  const [fileList, setFileList] = useState([]);

  const commentSidebarRef = useRef(null); //コメントサイドバーのref

  //#region something 既読を押したとき
  const handleReadClick = () => {
    setOpenRead({ open: true, kbn: "timeline" });
  };

  const handleReadClose = useCallback(() => {
    setOpenRead({ ...openRead, open: false });
  }, [openRead]);

  const MemoReadMember = useMemo(() => {
    return (
      <ShowTimelineRead
        open={openRead}
        handleClose={handleReadClose}
        timelineid={article?.timelineid}
        kbnname={article?.kbnname}
      />
    );
  }, [openRead]);

  //  #endregion

  //#region something コメントアイコンを押したとき
  const handleCommentClick = () => {
    setCommentSidebarOpen(true);
  }; //コメントアイコンクリック

  const handleCommentClose = () => {
    setCommentSidebarOpen(!commentSidebarOpen);
  }; //コメントアイコン閉じる

  //  #endregion

  //#region something ダイアログ関係
  const handleClickOpen = (honbuid) => {
    setShowUser({ open: true, honbuid: honbuid });
    setShowUserInfoOpen(true);
  }; //ユーザー詳細を開く

  const handleMeClose = () => {
    setShowUser({ ...showuser, open: false });
    setShowUserInfoOpen(false);
  }; //ユーザー詳細を閉じる

  const handleDeleteOpen = (index) => {
    setDeleteIndex({ open: true, index: index });
    setShowDeleteOpen(true);
  }; //削除ダイアログを開く

  const handleDeleteClose = () => {
    setDeleteIndex({ ...showuser, open: false });
    setShowDeleteOpen(false);
  }; //削除ダイアログを閉じる

  const handleOutsideClick = (event) => {
    if (
      commentSidebarOpen &&
      !showUserInfoOpen &&
      !showDeleteOpen &&
      commentSidebarRef.current &&
      !commentSidebarRef.current.contains(event.target)
    ) {
      setCommentSidebarOpen(false);
    }
  }; //コメントサイドバーを要素外をクリックして閉じる

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [commentSidebarOpen, showUserInfoOpen, showDeleteOpen]); //コメントサイドバーを要素外をクリックされたか判定

  //  #endregion

  //#region something お気に入りを押したとき
  const handleFavoriteClick = async () => {
    await hubConnection.invoke(
      "SendTimelineFavorite",
      article.timelineid,
      state.honbuid,
      article.ismyfavorite === "1" ? "0" : "1"
    );
  };

  //  #endregion

  //#region something タイムライン詳細を閉じるとき
  const handleDialogClose = () => {
    favocheck();
    handleClose();
  };

  const favocheck = async () => {
    if (article.ismyfavorite === "0" && nowfavo === "1") {
      await dispatch({
        type: "DELETE_TIMELINE_FAVORITE",
        payload: { timelineid: article.timelineid },
      });
    }
  };

  //  #endregion

  useEffect(() => {
    setFileList([]);
    setCommentSidebarOpen(false);
    if (open && timelineData) {
      const selectedArticle = timelineData;
      setArticle(selectedArticle);
      FileListGet();
      setLoading(false);
    } else if (!open) {
      setLoading(true);
      setArticle(null);
    }
  }, [open, timelineData]); //最初に読み込む

  // 添付ファイル一覧取得
  const FileListGet = async () => {
    const sql = `${API_URL}/GetTimelineFile?timelineid=${timelineData.timelineid}`;
    const result = await custom_axios(sql);

    const status = result.status;
    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      if (result.data && result.data.filelist) {
        const filelist = result.data.filelist;
        const fileDataList = filelist.map((file) => {
          const byteString = window.atob(file.fileBytes);
          const mimeType = file.mimetype;
          const content = new Uint8Array(byteString.length);
          for (let j = 0; j < byteString.length; j++) {
            content[j] = byteString.charCodeAt(j);
          }
          const blob = new File([content], file.filename, { type: mimeType });
          return {
            name: file.filename,
            size: blob.size,
            file: blob,
          };
        });
        setFileList(fileDataList);
      }
    }
  };

  return (
    <Dialog fullWidth maxWidth={"lg"} open={open} onClose={handleDialogClose}>
      <StyledDialogTitle id="max-width-dialog-title">
        <div className="show-member-search">
          <div className="show-member-search">ポスト詳細 {loading ? " (読込中...)" : ""}</div>
          <div className="question-title-actions">
            <StyledButton onClick={handleDialogClose} variant="outlined">
              閉じる (Esc)
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>

      {article?.iswebview === "1" ? (
        <Iframe
          url={article.message}
          width="100%"
          height="100%"
          id=""
          className=""
          display="block"
          position="relative"
        />
      ) : (
        <ContentContainer>
          {loading ? (
            <CircularProgress />
          ) : (
            <div>
              <h1 className="flex-div">{article.title}</h1>

              <div className="flex-div">
                {article.name} - {article.time}
                <Tooltip title="既読">
                  <Chip
                    label={article.kbnname}
                    size="small"
                    color={article.kbnname === "全員" ? "black" : "primary"}
                    variant="outlined"
                    sx={{ ml: 2 }}
                    onClick={handleReadClick}
                  />
                </Tooltip>
              </div>

              <div className="flex-div">
                <Divider sx={{ my: 2.5, width: "800px" }} />
              </div>
              <div className="flex-div">
                <StyledMessage>
                  {article.filecheck === "1" && (
                    <img
                      src={API_URL + `/GetTimelineThumbnail?timelineid=${article.timelineid}`}
                      alt={article.title}
                      style={{
                        maxWidth: "400px",
                        maxHeight: "300px",
                        margin: "0 0 20px 0",
                      }} /* styleでないと読み込まれない */
                    />
                  )}
                  <Linkify
                    componentDecorator={(decoratedHref, decoratedText, key) => (
                      <a target={`_blank`} href={decoratedHref} key={key} rel="noopener noreferrer">
                        {decoratedText}
                      </a>
                    )}
                  >
                    <div className="message-text">{article.message}</div>
                  </Linkify>
                </StyledMessage>
              </div>
            </div>
          )}
        </ContentContainer>
      )}

      <StyledFooter>
        {fileList.length > 0 && (
          <StyledFileList>
            {fileList.map((file, index) => (
              <StyledFileListItem key={index}>
                <StyledFileLink href={URL.createObjectURL(file.file)} download={file.name}>
                  {file.name} ({Math.round(file.size / 1024)} KB)
                </StyledFileLink>
              </StyledFileListItem>
            ))}
          </StyledFileList>
        )}
        {article?.iscomment === "1" && (
          <div className="flex-div">
            <Tooltip title="コメント">
              <IconButton aria-label="comment" onClick={handleCommentClick}>
                <CommentIcon className="timeline-icon" sx={{ fontSize: 30 }} />
              </IconButton>
            </Tooltip>
            <CommentCount>{article?.comment ?? 0}件</CommentCount>
          </div>
        )}
        {article?.viewcount && (
          <div className="flex-div">
            <Tooltip title="既読数">
              <IconButton aria-label="comment" onClick={handleReadClick}>
                <VisibilityOutlinedIcon className="timeline-icon" sx={{ fontSize: 30 }} />
              </IconButton>
            </Tooltip>
            <CommentCount>{article?.viewcount ?? 0}人</CommentCount>
          </div>
        )}
        <Tooltip title={article?.ismyfavorite === "1" ? "お気に入り解除" : "お気に入り"}>
          <IconButton aria-label="favorite" onClick={handleFavoriteClick}>
            {article?.ismyfavorite === "1" ? (
              <FavoriteIcon className="timeline-icon liked" sx={{ fontSize: 30 }} />
            ) : (
              <FavoriteBorderIcon className="timeline-icon" sx={{ fontSize: 30 }} />
            )}
          </IconButton>
        </Tooltip>
      </StyledFooter>

      {commentSidebarOpen && (
        <Slide direction="left" in={commentSidebarOpen}>
          <Box
            id="comment-sidebar"
            ref={commentSidebarRef}
            position="fixed"
            right={0}
            top={0}
            bottom={0}
            width={"520px"}
            bgcolor="background.paper"
            boxShadow={1}
          >
            <ShowTimelineComment
              timelineid={article?.timelineid}
              handleClose={handleCommentClose}
              handleClickOpen={handleClickOpen}
              handleMeClose={handleMeClose}
              showuser={showuser}
              handleDeleteClose={handleDeleteClose}
              handleDeleteOpen={handleDeleteOpen}
              showdeleteidex={showdeleteidex}
              open={{ open: commentSidebarOpen }}
            />
          </Box>
        </Slide>
      )}

      {MemoReadMember}
    </Dialog>
  );
}

export default ShowTimelineDetail;
